<!-- 平台管理 - 人员管理 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div
                class="admin-content"
                :style="{ minHeight: adminContentMinHeight + 'px' }"
            >
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 全部人员</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form ref="staffQueryForm" :model="staffQueryForm">
                            <el-row :gutter="20">
                                <el-col :span="4" :offset="2">
                                    <el-form-item prop="staffName">
                                        <el-input
                                            v-model="staffQueryForm.staffName"
                                            :maxlength="100"
                                            placeholder="人员名称"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item prop="idcard">
                                        <el-input
                                            v-model="staffQueryForm.idcard"
                                            :maxlength="100"
                                            placeholder="身份证号码"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item prop="staffRole">
                                        <el-select
                                            v-model="staffQueryForm.staffRole"
                                            clearable
                                            placeholder="人员角色"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                label="营销员"
                                                value="salesman"
                                            ></el-option>
                                            <el-option
                                                label="团队长"
                                                value="teamleader"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" v-if="canShowAllOrg">
                                    <el-form-item prop="orgId">
                                        <el-select
                                            v-model="staffQueryForm.orgId"
                                            clearable
                                            filterable
                                            :filter-method="filterAllOrgs"
                                            @visible-change="
                                                resetOrgSelectFilterQuery
                                            "
                                            placeholder="所属组织机构"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                v-for="item in staffQueryOrgSelectOptions"
                                                :key="item.orgId"
                                                :label="item.orgName"
                                                :value="item.orgId"
                                                class="org-select-option"
                                            >
                                                <span class="option-left">{{
                                                    item.orgCode
                                                }}</span>
                                                <span class="option-right">{{
                                                    item.orgName
                                                }}</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="4" :offset="2">
                                    <el-form-item prop="staffSource">
                                        <el-select
                                            v-model="staffQueryForm.staffSource"
                                            clearable
                                            placeholder="来源类型"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                label="用户注册"
                                                :value="0"
                                            ></el-option>
                                            <el-option
                                                label="平台导入"
                                                :value="1"
                                            ></el-option>
                                            <el-option
                                                label="平台创建"
                                                :value="2"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item prop="leaderStaffId">
                                        <el-select
                                            v-model="
                                                staffQueryForm.leaderStaffId
                                            "
                                            clearable
                                            placeholder="所属团队长(名称或身份证模糊搜索)"
                                            filterable
                                            remote
                                            :remote-method="loadLeaderStaffs"
                                            :loading="leaderStaffQueryLoading"
                                            @clear="
                                                clearLeaderStaffQuerySelectOptions
                                            "
                                            class="el-full-width"
                                        >
                                            <el-option
                                                v-for="item in leaderStaffQuerySelectOptions"
                                                :key="item.staffId"
                                                :label="item.staffName"
                                                :value="item.staffId"
                                                class="leader-select-option"
                                            >
                                                <span class="option-left">{{
                                                    item.idcard
                                                }}</span>
                                                <span class="option-right">{{
                                                    item.staffName
                                                }}</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item class="el-align-right">
                                        <el-button
                                            @click="resetStaffQueryForm"
                                            icon="fas fa-undo"
                                            >重 置</el-button
                                        >&nbsp;&nbsp;&nbsp;&nbsp;
                                        <el-button
                                            type="primary"
                                            @click="queryStaffList(1000)"
                                            icon="fas fa-search"
                                            >查 询</el-button
                                        >
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-toolbar">
                        <el-button-group>
                            <el-button
                                type="primary"
                                size="small"
                                icon="fas fa-plus-circle"
                                @click="openStaffEditDialog('add')"
                                >添加人员</el-button
                            >
                            <el-button
                                type="primary"
                                size="small"
                                icon="fas fa-upload"
                                @click="openStaffImportDialog()"
                                >批量导入</el-button
                            >
                            <el-button
                                type="primary"
                                size="small"
                                icon="fas fa-minus-circle"
                                @click="batchDeleteStaffs()"
                                >批量删除</el-button
                            >
                        </el-button-group>
                    </div>
                    <div class="el-search-list">
                        <el-table
                            ref="staffTable"
                            v-loading="staffQueryLoading"
                            element-loading-text="拼命加载中..."
                            element-loading-custom-class="el-loading-mask-opacity"
                            :class="{ loading: staffQueryLoading }"
                            :data="staffList"
                            :default-sort="staffQuerySort"
                            @sort-change="onStaffQuerySortChange"
                            @selection-change="onStaffSelectionChange"
                            style="width:100%;"
                            class="el-table-overflow-x-hidden"
                            empty-text="暂无数据"
                        >
                            <el-table-column
                                type="selection"
                                width="60"
                            ></el-table-column>
                            <el-table-column
                                label="#"
                                type="index"
                                width="50"
                            ></el-table-column>
                            <el-table-column
                                label="人员名称"
                                prop="staffName"
                                width="150"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="身份证号码"
                                prop="idcard"
                                width="180"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="人员角色"
                                prop="staffRole"
                                width="150"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <el-tag
                                        size="small"
                                        :type="
                                            getStaffRoleTagType(
                                                scope.row.staffRole
                                            )
                                        "
                                        >{{ scope.row.staffRoleName }}</el-tag
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="所属组织机构"
                                prop="orgName"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="所属团队长"
                                prop="leaderStaffName"
                                width="150"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="创建时间"
                                prop="createTime"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="操作"
                                width="140"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        @click="
                                            openStaffViewDialog(
                                                'view',
                                                scope.row
                                            )
                                        "
                                        >查看详情</el-button
                                    >
                                    <el-dropdown
                                        size="small"
                                        trigger="click"
                                        @command="
                                            handleStaffCommand(
                                                arguments[0],
                                                scope.row
                                            )
                                        "
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="el-icon-arrow-down el-icon--right"
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="view"
                                                >查看详情</el-dropdown-item
                                            >
                                            <el-dropdown-item command="edit"
                                                >修改人员</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                command="delete"
                                                divided
                                                >删除人员</el-dropdown-item
                                            >
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination
                            background
                            v-show="showStaffQueryPager"
                            @current-change="onStaffQueryCurrentPageChange"
                            :current-page.sync="staffQueryForm.currentPage"
                            :page-size="staffQueryForm.pageSize"
                            layout="slot, prev, pager, next, total"
                            :total="staffQueryTotal"
                        >
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button
                                        :class="{
                                            active:
                                                staffQueryForm.pageSize == 10
                                        }"
                                        @click="onStaffQueryPageSizeChange(10)"
                                        >10</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                staffQueryForm.pageSize == 20
                                        }"
                                        @click="onStaffQueryPageSizeChange(20)"
                                        >20</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                staffQueryForm.pageSize == 50
                                        }"
                                        @click="onStaffQueryPageSizeChange(50)"
                                        >50</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                staffQueryForm.pageSize == 100
                                        }"
                                        @click="onStaffQueryPageSizeChange(100)"
                                        >100</el-button
                                    >
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>

                    <!-- 添加/修改Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="staffEditDialogVisible"
                        @closed="closeStaffEditDialog"
                    >
                        <span slot="title" class="el-drawer-title">{{
                            staffEditDialogTitle
                        }}</span>
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                v-custom-validator-apply="staffEditRules"
                                ref="staffEditForm"
                                :model="staffEditForm"
                                :rules="staffEditRules"
                                label-width="300px"
                            >
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="人员名称"
                                            prop="staffName"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        staffEditForm.staffName
                                                    "
                                                    :maxlength="50"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    2~50个汉字、字母、数字及下划线组成.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="身份证号码"
                                            prop="idcard"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        staffEditForm.idcard
                                                    "
                                                    :maxlength="50"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    身份证号码由15位数字或18位数字组成.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row v-if="canShowAllOrg">
                                    <el-col :span="24">
                                        <el-form-item
                                            label="所属组织机构"
                                            prop="orgId"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        staffEditForm.orgId
                                                    "
                                                    filterable
                                                    :filter-method="
                                                        filterAllOrgs
                                                    "
                                                    @visible-change="
                                                        resetOrgSelectFilterQuery
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in staffQueryOrgSelectOptions"
                                                        :key="item.orgId"
                                                        :label="item.orgName"
                                                        :value="item.orgId"
                                                        class="org-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.orgCode
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.orgName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="人员角色"
                                            prop="staffRole"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        staffEditForm.staffRole
                                                    "
                                                    @change="
                                                        applyDynamicStaffEditRules
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        label="营销员"
                                                        value="salesman"
                                                    ></el-option>
                                                    <el-option
                                                        label="团队长"
                                                        value="teamleader"
                                                    ></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row
                                    v-if="staffEditForm.staffRole == 'salesman'"
                                >
                                    <el-col :span="24">
                                        <el-form-item
                                            label="所属团队长"
                                            prop="leaderStaffId"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        staffEditForm.leaderStaffId
                                                    "
                                                    placeholder="请输入(支持名称或身份证模糊搜索)"
                                                    filterable
                                                    remote
                                                    :remote-method="
                                                        loadLeaderStaffs
                                                    "
                                                    :loading="
                                                        leaderStaffQueryLoading
                                                    "
                                                    @clear="
                                                        clearLeaderStaffQuerySelectOptions
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in leaderStaffQuerySelectOptions"
                                                        :key="item.staffId"
                                                        :label="item.staffName"
                                                        :value="item.staffId"
                                                        class="leader-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.idcard
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.staffName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="手机号码"
                                            prop="mobilePhone"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        staffEditForm.mobilePhone
                                                    "
                                                    :maxlength="11"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="电子邮箱"
                                            prop="email"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        staffEditForm.email
                                                    "
                                                    :maxlength="100"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item class="read-form-item">
                                            <el-checkbox
                                                class="remember-me"
                                                v-model="readFlag"
                                            >
                                                已向本人告知并取得其对提供敏感个人信息的同意，详情可查看
                                                <a
                                                    href="https://file.ht-insurance.com/20260814/94727304ab47499db835d491ca6be137.pdf"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    《敏感个人信息收集处理授权书》
                                                </a>
                                            </el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeStaffEditDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="saveStaff"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 导入Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="staffImportDialogVisible"
                        @closed="closeStaffImportDialog"
                    >
                        <span slot="title" class="el-drawer-title"
                            >批量导入人员</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                v-custom-validator-apply="staffImportRules"
                                ref="staffImportForm"
                                :model="staffImportForm"
                                :rules="staffImportRules"
                                label-width="300px"
                            >
                                <el-row v-if="canShowAllOrg">
                                    <el-col :span="24">
                                        <el-form-item
                                            label="所属组织机构"
                                            prop="orgId"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        staffImportForm.orgId
                                                    "
                                                    filterable
                                                    :filter-method="
                                                        filterAllOrgs
                                                    "
                                                    @visible-change="
                                                        resetOrgSelectFilterQuery
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in staffQueryOrgSelectOptions"
                                                        :key="item.orgId"
                                                        :label="item.orgName"
                                                        :value="item.orgId"
                                                        class="org-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.orgCode
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.orgName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="人员角色"
                                            prop="staffRole"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        staffImportForm.staffRole
                                                    "
                                                    @change="
                                                        applyDynamicStaffImportRules
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        label="营销员"
                                                        value="salesman"
                                                    ></el-option>
                                                    <el-option
                                                        label="团队长"
                                                        value="teamleader"
                                                    ></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <!-- 仅在添加营销员时才选择所属团队长 -->
                                <el-row
                                    v-if="
                                        staffImportForm.staffRole == 'salesman'
                                    "
                                >
                                    <el-col :span="24">
                                        <el-form-item
                                            label="所属团队长"
                                            prop="leaderStaffId"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        staffImportForm.leaderStaffId
                                                    "
                                                    placeholder="请输入(支持名称或身份证模糊搜索)"
                                                    filterable
                                                    remote
                                                    :remote-method="
                                                        loadLeaderStaffs
                                                    "
                                                    :loading="
                                                        leaderStaffQueryLoading
                                                    "
                                                    @clear="
                                                        clearLeaderStaffQuerySelectOptions
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in leaderStaffQuerySelectOptions"
                                                        :key="item.staffId"
                                                        :label="item.staffName"
                                                        :value="item.staffId"
                                                        class="leader-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.idcard
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.staffName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="上传EXCEL文件"
                                            prop="uploadExcelFilePath"
                                        >
                                            <el-col :span="12">
                                                <el-upload
                                                    class="upload-excel"
                                                    ref="staffImportUploader"
                                                    name="uploadFile"
                                                    :multiple="false"
                                                    :limit="1"
                                                    :on-exceed="
                                                        handleImportExcelExceed
                                                    "
                                                    :headers="uploadHeaders"
                                                    :action="
                                                        importExcelUploadUrl
                                                    "
                                                    :data="
                                                        importExcelUploadParam
                                                    "
                                                    :before-upload="
                                                        beforeImportExcelUpload
                                                    "
                                                    :on-remove="
                                                        handleImportExcelRemove
                                                    "
                                                    :on-success="
                                                        handleImportExcelUploadSuccess
                                                    "
                                                    :on-error="
                                                        handleUploadError
                                                    "
                                                >
                                                    <el-button
                                                        slot="trigger"
                                                        size="small"
                                                        type="primary"
                                                        icon="fas fa-plus-circle"
                                                        >选择文件</el-button
                                                    >
                                                    <a
                                                        class="excel-template"
                                                        href="javascript:;"
                                                        @click="
                                                            downloadTemplateExcel
                                                        "
                                                        >下载模板</a
                                                    >
                                                    <div
                                                        class="el-upload__tip"
                                                        slot="tip"
                                                    >
                                                        只能上传xls|xlsx格式的EXCEL文件，大小不超过1MB!
                                                    </div>
                                                </el-upload>
                                                <div
                                                    v-if="
                                                        showStaffImportFeedback
                                                    "
                                                >
                                                    <p class="import-feedback">
                                                        上传EXCEL中部分数据校验不通过，请点此<a
                                                            href="javascript:;"
                                                            @click="
                                                                downloadFeedbackExcel
                                                            "
                                                            >链接下载</a
                                                        >反馈信息予以更正并重新上传导入.
                                                    </p>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item class="read-form-item">
                                            <el-checkbox
                                                class="remember-me"
                                                v-model="importReadFlag"
                                            >
                                                已向本人告知并取得其对提供敏感个人信息的同意，详情可查看
                                                <a
                                                    href="https://file.ht-insurance.com/20260814/94727304ab47499db835d491ca6be137.pdf"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    《敏感个人信息收集处理授权书》
                                                </a>
                                            </el-checkbox>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeStaffImportDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="importStaff"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 查看Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="staffViewDialogVisible"
                        @closed="closeStaffViewDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            查看人员信息</span
                        >
                        <div class="el-drawer-content">
                            <div class="el-drawer-content-body">
                                <el-form
                                    class="el-form-detail"
                                    inline
                                    label-position="right"
                                    label-width="120px"
                                    label-suffix="："
                                >
                                    <el-form-item label="人员ID">{{
                                        staffViewForm.staffId
                                    }}</el-form-item>
                                    <el-form-item label="人员来源">{{
                                        staffViewForm.staffSourceName
                                    }}</el-form-item>

                                    <el-form-item label="人员名称">{{
                                        staffViewForm.staffName
                                    }}</el-form-item>
                                    <el-form-item label="身份证号码">{{
                                        staffViewForm.idcard
                                    }}</el-form-item>

                                    <el-form-item label="人员角色">
                                        <el-tag
                                            size="small"
                                            :type="
                                                getStaffRoleTagType(
                                                    staffViewForm.staffRole
                                                )
                                            "
                                            >{{
                                                staffViewForm.staffRoleName
                                            }}</el-tag
                                        >
                                    </el-form-item>
                                    <el-form-item label="所属团队长">
                                        <span v-if="staffViewForm.leaderIdcard"
                                            >{{
                                                staffViewForm.leaderStaffName
                                            }}({{
                                                staffViewForm.leaderIdcard
                                            }})</span
                                        >
                                        <span v-else>-</span>
                                    </el-form-item>

                                    <el-form-item
                                        label="所属组织机构"
                                        style="width:100%;"
                                        >{{
                                            staffViewForm.orgName
                                        }}</el-form-item
                                    >

                                    <el-form-item label="手机号码">{{
                                        staffViewForm.mobilePhone
                                    }}</el-form-item>
                                    <el-form-item label="电子邮箱">{{
                                        staffViewForm.email
                                    }}</el-form-item>

                                    <el-form-item label="创建时间">{{
                                        staffViewForm.createTime
                                    }}</el-form-item>
                                    <el-form-item label="修改时间">{{
                                        staffViewForm.updateTime
                                    }}</el-form-item>
                                </el-form>
                            </div>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeStaffViewDialog"
                                    >关 闭</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { COMMON_PATTERNS, mapSort, parseFilename } from '@/utils.js';
import FileSaver from 'file-saver';

const EXCEL_TYPES = ['xls', 'xlsx'];

export default {
    name: 'StaffInfo',
    data() {
        return {
            submiting: false,
            vispRoleList: [],
            allOrgList: [],
            orgSelectFilterQuery: '',
            staffList: [],
            staffQueryLoading: false,
            staffQuering: false,
            staffQueryForm: {
                staffName: '',
                idcard: '',
                leaderIdcard: '',
                orgId: '',
                staffRole: '',
                staffSource: '',
                pageSize: 10,
                currentPage: 1
            },
            staffQueryTotal: 0,
            staffQuerySort: {
                prop: 'createTime',
                order: 'descending'
            },
            currentActionType: 'add',
            staffEditDialogVisible: false,
            staffViewDialogVisible: false,
            staffImportDialogVisible: false,
            staffEditForm: {
                staffId: '',
                staffName: '',
                idcard: '',
                password: '',
                repassword: '',
                staffRole: '',
                orgId: '',
                leaderStaffId: '',
                mobilePhone: '',
                email: ''
            },
            staffEditRules: {
                orgId: [
                    {
                        type: 'integer',
                        required: true,
                        message: '请选择一个所属组织机构!'
                    }
                ],
                staffName: [
                    {
                        required: true,
                        message: '请输入人员名称!'
                    },
                    {
                        pattern: /^[a-zA-Z\u00a1-\uffff0-9_]{2,50}$/,
                        message: '人员名称由2~50个汉字、字母、数字及下划线组成!'
                    }
                ],
                idcard: [
                    {
                        required: true,
                        message: '请输入身份证号码!'
                    },
                    {
                        pattern: /(^\d{15}$)|(^\d{17}(\d{1}|X|x)$)/,
                        message: '身份证号码由15位数字或18位数字组成!'
                    }
                ],
                staffRole: [
                    {
                        required: true,
                        message: '请选择人员角色!'
                    }
                ],
                mobilePhone: [
                    {
                        pattern: COMMON_PATTERNS.MOBILE,
                        message: '手机号码不合法!'
                    }
                ],
                email: [
                    {
                        type: 'email',
                        message: 'EMAIL不合法!'
                    }
                ]
            },
            importExcelUploadUrl: PLATFORM_API.of(
                '/api/xupload/protected/file'
            ),
            importExcelUploadParam: {
                renameStrategy: 'ORIGINAL_FILENAME_AND_UUID',
                formatLimit: EXCEL_TYPES.join(',')
            },
            staffImportForm: {
                staffRole: '',
                leaderStaffId: '',
                orgId: '',
                uploadExcelFileName: '',
                uploadExcelFilePath: ''
            },
            staffImportRules: {
                orgId: [
                    {
                        type: 'integer',
                        required: true,
                        message: '请选择一个所属组织机构!'
                    }
                ],
                staffRole: [
                    {
                        required: true,
                        message: '请选择人员角色!'
                    }
                ],
                uploadExcelFilePath: [
                    {
                        required: true,
                        message: '请选择导入Excel文件!'
                    }
                ]
            },
            showStaffImportFeedback: false,
            leaderStaffQueryLoading: false,
            leaderStaffQuerySelectOptions: [],
            staffViewForm: {
                staffId: '',
                staffName: '',
                idcard: '',
                staffSourceName: '',
                leaderStaffId: '',
                leaderStaffName: '',
                leaderIdcard: '',
                staffRole: '',
                staffRoleName: '',
                orgName: '',
                mobilePhone: '',
                email: '',
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: ''
            },
            batchDeleteStaffIds: [],
            readFlag: false,
            importReadFlag: false
        };
    },
    computed: {
        ...mapGetters(['isOrgSelf']),
        loginUser() {
            return this.$store.state.loginUserAllData.loginUser;
        },
        canShowAllOrg() {
            return this.loginUser.userType === 0 || !this.isOrgSelf;
        },
        showStaffQueryPager() {
            if (this.staffQuering || this.staffQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        staffEditDialogTitle() {
            if (this.currentActionType == 'add') {
                return '添加人员';
            } else if (this.currentActionType == 'edit') {
                return '修改人员';
            } else {
                return '';
            }
        },
        staffQueryOrgSelectOptions() {
            if (this.orgSelectFilterQuery) {
                return this.allOrgList.filter(org => {
                    if (org.orgCode.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    if (org.orgName.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    return false;
                });
            } else {
                return this.allOrgList.filter(org => true);
            }
        },
        uploadHeaders() {
            let headers = {
                Accept: 'application/json'
            };
            let accessToken = this.$store.getters.getAccessToken();
            if (accessToken && accessToken.access_token) {
                headers['Authorization'] = 'bearer ' + accessToken.access_token;
            }
            return headers;
        }
    },
    created() {},
    mounted() {
        if (this.canShowAllOrg) {
            this.loadAllOrgList();
        }
        this.queryStaffList(1000);
    },
    methods: {
        getStaffRoleTagType(staffRole) {
            if (staffRole == 'teamleader') {
                return 'success';
            } else {
                return 'primary';
            }
        },
        filterAllOrgs(value) {
            this.orgSelectFilterQuery = value;
        },
        loadAllOrgList() {
            let url = PLATFORM_API.of('/api/platform/upms/org/all');
            this.$http
                .get(url)
                .then(response => {
                    let result = response.data;
                    if (result.success) {
                        this.allOrgList = result.data;
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        resetOrgSelectFilterQuery() {
            this.orgSelectFilterQuery = '';
        },
        loadLeaderStaffs(query) {
            if (query) {
                this.leaderStaffQueryLoading = true;
                let url = PLATFORM_API.of('/api/platform/visp/staff/leaders');
                this.$http
                    .get(url, {
                        params: { staffName: query, idcard: query }
                    })
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.leaderStaffQuerySelectOptions = result.data;
                        } else {
                            this.leaderStaffQuerySelectOptions = [];
                        }
                    })
                    .catch(error => {
                        this.leaderStaffQuerySelectOptions = [];
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        this.leaderStaffQueryLoading = false;
                    });
            }
        },
        clearLeaderStaffQuerySelectOptions() {
            this.leaderStaffQuerySelectOptions = [];
        },
        queryStaffList(loading) {
            this.staffQueryForm.currentPage = 1;
            this.doQueryStaffList(loading);
        },
        doQueryStaffList(loading) {
            this.staffQuering = true;
            if (loading) {
                this.staffQueryLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    this.staffQueryForm,
                    mapSort(this.staffQuerySort)
                );
                this.$http
                    .get(PLATFORM_API.of('/api/platform/visp/staff/list'), {
                        params: params
                    })
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.staffList = result.data;
                            this.staffQueryTotal = result.totalRowCount;
                        } else {
                            this.staffList = [];
                            this.staffQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch(error => {
                        this.staffList = [];
                        this.staffQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.staffQueryLoading = false;
                        }
                        this.staffQuering = false;
                    });
            }, loading);
        },
        resetStaffQueryForm() {
            this.$refs.staffQueryForm.resetFields();
            this.leaderStaffQuerySelectOptions = [];
        },
        onStaffSelectionChange(selectedRows) {
            if (selectedRows && selectedRows.length) {
                this.batchDeleteStaffIds = [];
                selectedRows.forEach(row => {
                    this.batchDeleteStaffIds.push(row.staffId);
                });
            } else {
                this.batchDeleteStaffIds = [];
            }
        },
        onStaffQuerySortChange(parameter) {
            if (
                this.staffQuerySort.prop != parameter.prop ||
                this.staffQuerySort.order != parameter.order
            ) {
                this.staffQuerySort.prop = parameter.prop;
                this.staffQuerySort.order = parameter.order;
                this.queryStaffList(1000);
            }
        },
        onStaffQueryPageSizeChange(pageSize) {
            this.staffQueryForm.pageSize = pageSize;
            this.queryStaffList(1000);
        },
        onStaffQueryCurrentPageChange(currentPage) {
            this.staffQueryForm.currentPage = currentPage;
            this.doQueryStaffList(1000);
        },
        handleStaffCommand(cmd, row) {
            if (cmd == 'edit') {
                this.openStaffEditDialog(cmd, row);
            } else if (cmd == 'view') {
                this.openStaffViewDialog(cmd, row);
            } else if (cmd == 'delete') {
                this.deleteStaff(row);
            } else if (cmd == 'config') {
                this.openStaffViewDialog(cmd, row);
            }
        },
        openStaffEditDialog(cmd, row) {
            this.currentActionType = cmd;
            this.staffEditDialogVisible = true;
            this.leaderStaffQuerySelectOptions = [];
            if (cmd == 'edit') {
                Vue.nextTick(() => {
                    Object.keys(this.staffEditForm).forEach(name => {
                        let value = row[name];
                        this.staffEditForm[name] = value;
                    });
                    this.applyDynamicStaffEditRules(
                        this.staffEditForm.staffRole
                    );
                    //渲染团队长下拉选择框的选中状态
                    this.leaderStaffQuerySelectOptions.push({
                        staffId: row['leaderStaffId'],
                        staffName: row['leaderStaffName'],
                        idcard: row['leaderIdcard']
                    });
                });
            }
        },
        closeStaffEditDialog() {
            this.submiting = false;
            this.staffEditDialogVisible = false;
            this.resetStaffEditRules();
            this.$refs.staffEditForm.resetFields();
            //手动reset
            this.staffEditForm.staffId = '';
            this.leaderStaffQuerySelectOptions = [];
        },
        openStaffImportDialog() {
            this.staffImportDialogVisible = true;
            this.leaderStaffQuerySelectOptions = [];
        },
        closeStaffImportDialog() {
            this.staffImportDialogVisible = false;
            this.resetStaffImportRules();
            this.showStaffImportFeedback = false;
            this.$refs.staffImportForm.resetFields();
            this.$refs.staffImportUploader.clearFiles();
            this.leaderStaffQuerySelectOptions = [];
        },
        openStaffViewDialog(cmd, row) {
            this.currentActionType = cmd;
            this.staffViewDialogVisible = true;
            Vue.nextTick(() => {
                Object.keys(this.staffViewForm).forEach(name => {
                    let value = row[name];
                    this.staffViewForm[name] = value;
                });
            });
        },
        closeStaffViewDialog() {
            this.staffViewDialogVisible = false;
            Object.keys(this.staffViewForm).forEach(name => {
                this.staffViewForm[name] = '';
            });
            this.staffResourceList = [];
            this.checkedResourceIdList = [];
        },
        resetStaffEditRules() {
            delete this.staffEditRules['leaderStaffId'];
        },
        resetStaffImportRules() {
            delete this.staffImportRules['leaderStaffId'];
        },
        applyDynamicStaffEditRules(value) {
            if (value == 'salesman') {
                //当前选择的是营销员?
                //营销员需要设置团队长
                this.staffEditRules['leaderStaffId'] = [
                    {
                        type: 'integer',
                        required: true,
                        message: '请选择一个所属团队长!'
                    }
                ];
            } else {
                delete this.staffEditRules['leaderStaffId'];
            }
        },
        applyDynamicStaffImportRules(value) {
            if (value == 'salesman') {
                //当前选择的是营销员?
                //营销员需要设置团队长
                this.staffImportRules['leaderStaffId'] = [
                    {
                        type: 'integer',
                        required: true,
                        message: '请选择一个所属团队长!'
                    }
                ];
            } else {
                delete this.staffImportRules['leaderStaffId'];
            }
        },
        saveStaff() {
            let url = '';
            let method = 'post';
            if (this.currentActionType == 'add') {
                url = PLATFORM_API.of('/api/platform/visp/staff/create');
                method = 'post';
            } else if (this.currentActionType == 'edit') {
                url = PLATFORM_API.of('/api/platform/visp/staff/update');
                method = 'put';
            }
            if (url) {
                this.$refs.staffEditForm.validate(valid => {
                    if (valid && !this.submiting) {
                        if (!this.readFlag) {
                            this.$message.error(
                                '请确认是否已向本人告知并取得其对提供敏感个人信息的同意'
                            );
                            return false;
                        }
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http[method](url, this.staffEditForm)
                                .then(response => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeStaffEditDialog();
                                        this.$message.success(result.message);
                                        this.queryStaffList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    } else {
                        return false;
                    }
                });
            }
        },
        deleteStaff(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/staff/delete/' + row.staffId
            );
            this.$confirm('您确定要删除该人员?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .delete(url)
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.$message.success(result.message);
                            this.queryStaffList(1000);
                        } else {
                            this.$message.error(result.message);
                        }
                    })
                    .catch(defaultApiErrorHandler);
            });
        },
        batchDeleteStaffs() {
            if (this.batchDeleteStaffIds.length) {
                let url = PLATFORM_API.of(
                    '/api/platform/visp/staff/delete/batch'
                );
                this.$confirm('您确定要删除所选人员?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .post(url, this.batchDeleteStaffIds)
                        .then(response => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.queryStaffList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            } else {
                this.$message.error('请选择需要删除人员!');
            }
        },
        importStaff() {
            let url = PLATFORM_API.of('/api/platform/visp/staff/import');
            this.$refs.staffImportForm.validate(valid => {
                if (valid && !this.submiting) {
                    if (!this.importReadFlag) {
                        this.$message.error(
                            '请确认是否已向本人告知并取得其对提供敏感个人信息的同意'
                        );
                        return false;
                    }
                    this.submiting = true;
                    this.$http
                        .post(url, this.staffImportForm)
                        .then(response => {
                            let result = response.data;
                            if (result.success) {
                                this.closeStaffImportDialog();
                                this.$message.success(result.message);
                                this.queryStaffList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(error => {
                            defaultApiErrorHandler.call(this, error, result => {
                                if (result.code == 400) {
                                    this.showStaffImportFeedback = true;
                                }
                            });
                        })
                        .then(() => {
                            this.submiting = false;
                        });
                } else {
                    return false;
                }
            });
        },
        downloadTemplateExcel() {
            let url = PLATFORM_API.of('/api/xdownload/store/file');
            this.$http
                .post(
                    url,
                    {
                        targetFileName: '人员导入模板.xlsx',
                        targetFilePath: '/excel/templates/人员导入模板.xlsx'
                    },
                    {
                        responseType: 'blob' // 设置响应数据类型
                    }
                )
                .then(response => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler);
        },
        downloadFeedbackExcel() {
            let url = PLATFORM_API.of('/api/xdownload/temp/file');
            this.$http
                .post(
                    url,
                    {
                        targetFileName: this.staffImportForm
                            .uploadExcelFileName,
                        targetFilePath: this.staffImportForm.uploadExcelFilePath
                    },
                    {
                        responseType: 'blob' // 设置响应数据类型
                    }
                )
                .then(response => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler);
        },
        beforeImportExcelUpload(file) {
            let fileName = file.name;
            if (fileName.replace(/\s+/g, '') != fileName) {
                this.$message.error('上传文件名不能包含空格!');
                return false;
            }
            let fileType = fileName
                .substring(fileName.lastIndexOf('.') + 1)
                .toLowerCase();
            if (EXCEL_TYPES.indexOf(fileType) == -1) {
                this.$message.error(
                    '上传文件只能是EXCEL(xls、xlsx)格式的文件!'
                );
                return false;
            }
            if (file.size > 0 && file.size / 1024 / 1024 > 1) {
                this.$message.error('上传EXCEL文件大小不能超过1MB!');
                return false;
            }
            return true;
        },
        handleImportExcelExceed(file, fileList) {
            this.$message.error('最多只能上传一个文件!若要重新上传请先删除.');
            return false;
        },
        handleImportExcelUploadSuccess(response, file, fileList) {
            file.path = response.data.path;
            this.staffImportForm.uploadExcelFileName = response.data.name;
            this.staffImportForm.uploadExcelFilePath = response.data.path;
            this.showStaffImportFeedback = false;
            this.$refs.staffImportForm.validateField('uploadExcelFilePath');
        },
        handleImportExcelRemove(file, fileList) {
            this.showStaffImportFeedback = false;
            this.staffImportForm.uploadExcelFileName = '';
            this.staffImportForm.uploadExcelFilePath = '';
            try {
                if (file && file.path) {
                    this.$http.get(
                        PLATFORM_API.of(
                            '/api/xupload/protected/remove?path=' + file.path
                        )
                    );
                }
            } catch (e) {
                console.log(e);
            }
        },
        handleUploadError(error, file, fileList) {
            try {
                let result = JSON.parse(error.message);
                this.$message.error(result.message);
            } catch (e) {
                console.error(e);
            }
        }
    }
};
</script>
<style lang="scss">
.upload-excel {
    display: block;
    position: relative;

    .excel-template {
        display: inline-block;
        position: absolute;
        right: 0;
        top: 0;
        font-size: 13px;
    }
}
.org-select-option,
.leader-select-option {
    .option-left {
        float: left;
        color: $--color-primary;
        font-size: 13px;
    }
    .option-right {
        float: right;
    }
}
.import-feedback {
    margin-top: 10px;
    padding: 10px;
    line-height: 1.5;
    background-color: mix($--color-white, $--color-danger, 90%);
    border-radius: 4px;
    font-size: 13px;
    color: $--color-danger;
    a {
        color: $--color-blue;
    }
}
.read-form-item {
    .el-form-item__content {
        margin-left: 230px !important;
    }
}
</style>
